<template>
  <a-layout class="app_layout">
    <div class="layout__header" v-if="!isIframeOpen">
      <LayoutHeader ref="layoutHeader"></LayoutHeader>
    </div>
    <a-layout-content class="container">
      <div class="main__container" @mouseenter="handleMouseenter">
        <div class="porta-renderer-wrapper">
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>
          </router-view>
        </div>
        <!-- <div class="porta-renderer-wrapper">
          <keep-alive>
            <router-view v-slot="{ Component }">
              <component :is="Component" :key="$route.path" />
            </router-view>
          </keep-alive>
        </div> -->
      </div>
    </a-layout-content>
  </a-layout>
</template>
<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref, watch } from "vue";
import layoutMenu from "./menu/menu.vue";
import LayoutHeader from "./header/index.vue";
import aIcon from "@/components/aicon/aicon.vue";
import { mapState } from "vuex";
import { useRoute } from "vue-router";
// import useGlobalEventBus from "@/hooks/useGlobalEventBus";
import WujieVue from "wujie-vue3";
import dayjs from "dayjs";
import { getRefreshSession } from "@/api/login";
import AuthRefreshService from "@/utils/authRefreshService";
declare global {
  interface Window {
    authRefreshService?: AuthRefreshService;
    MSG_KEY?: any;
  }
}
const { bus } = WujieVue;
export default defineComponent({
  name: "layout",
  components: {
    layoutMenu,
    LayoutHeader,
    aIcon,
  },
  setup() {
    const collapsed = ref<boolean>(false);
    const route = useRoute();
    let refreshTime: any = null;
    // const authRefreshService = AuthRefreshService.getInstance(3600); // 提前 1 小时刷新
    // const authRefreshService = AuthRefreshService.getInstance(600); // 提前 10 分钟刷新
    onMounted(() => {
      const authRefreshService = AuthRefreshService.getInstance(3600); // 提前 1 小时刷新
      authRefreshService.checkAndRefreshToken(); // 检查并刷新 Token

      const CHECK_INTERVAL = 1000 * 60 * 150; // 没多久刷新
      const INTERVAL_TIME = 1000 * 60 * 5; //沒多少秒检查一次
      const LAST_REFRESH_KEY = "lastRefreshTime"; // 定义 localStorage 的 key
      let refreshTime: any = null;
      //测试环境一分钟检查一次，生产 5分钟
      const checkAndRefresh = () => {
        // eslint-disable-next-line no-console
        console.log("开始检查", dayjs().format("YYYY-MM-DD HH:mm:ss"));
        const lastRefresh = localStorage.getItem(LAST_REFRESH_KEY);
        const now = Date.now();
        if (lastRefresh) {
          // eslint-disable-next-line no-console
          console.log(dayjs(now).format("YYYY-MM-DD HH:mm:ss"), "当前时间");
          // eslint-disable-next-line no-console
          console.log(
            dayjs(parseInt(lastRefresh)).format("YYYY-MM-DD HH:mm:ss"),
            "最后一次更新时间"
          );
          // eslint-disable-next-line no-console
          console.log(now - parseInt(lastRefresh), "毫秒以后刷新");
          // eslint-disable-next-line no-console
          console.log(
            !lastRefresh || now - parseInt(lastRefresh) > CHECK_INTERVAL,
            "是否符合刷新条件"
          );
        }

        // 如果上次刷新时间超过 30 分钟，则执行刷新
        if (!lastRefresh || now - parseInt(lastRefresh) > CHECK_INTERVAL) {
          // eslint-disable-next-line no-console
          console.log("距离上次刷新超过：", CHECK_INTERVAL, "毫秒开始刷新");
          localStorage.setItem(LAST_REFRESH_KEY, now.toString()); // 更新刷新时间
          // eslint-disable-next-line no-console
          getRefreshSession(); // 执行刷新逻辑
        }
      };
      // 定时检查
      if (!refreshTime) {
        refreshTime = setInterval(() => {
          authRefreshService.checkAndRefreshToken(); // 检查并刷新 Token
          checkAndRefresh();
        }, INTERVAL_TIME);
      }
    });
    onBeforeUnmount(() => {
      clearInterval(refreshTime);
      refreshTime = null;
    });

    watch(
      () => route.hash,
      () => {
        bus.$emit("HASH_CHANGE", { ...window.location });
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return { collapsed };
  },
  computed: {
    ...mapState({
      includeList: (state: any) => state.keepAlive.includeList,
      isShowMenu: (state: any) => state.user.isShowMenu,
    }),
    isIframeOpen() {
      return window.self !== window.top;
    },
  },
  methods: {
    handleMouseenter() {
      if (!this.isShowMenu) {
        return;
      }
      (this.$refs.layoutHeader as any).handleHideMenu();
    },
  },
});
</script>
<style lang="scss" scoped>
.app_layout {
  position: relative;
  height: 100vh;
  width: 100%;
  background-color: #dce1e7;
  // overflow: hidden;

  .layout__header {
    position: relative;
  }

  .container {
    position: relative;
    height: 100vh;
    // margin-top: 76px;
    width: 100%;
    padding-bottom: 5px;
    overflow: auto;
    background-color: #dce1e7;
  }

  .main__container {
    background-color: #dce1e7;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .porta-renderer-wrapper {
    padding: 0px 10px 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    max-width: 100%;
    overflow: hidden;
    height: 100%;
    -webkit-transform: translateX(0px);
    transform: translate(0);
    background-color: #dce1e7;
  }

  & .header {
    background-color: #dce1e7;
    padding: 0;
    height: 40px;
  }

  & .container::-webkit-scrollbar {
    width: 6px;
  }

  & .container::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px #d8d8d8;
    background: #c1c1c1;
  }

  & .container::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #d8d8d8;
    background: #ededed;
  }
}
</style>
